/* tslint:disable */
/* eslint-disable */
/**
 * P4m.Module.Auth.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientAllClaimReadDto
 */
export interface ClientAllClaimReadDto {
    /**
     * Тип клейма
     * @type {string}
     * @memberof ClientAllClaimReadDto
     */
    clientId: string;
    /**
     * Имя клейма
     * @type {string}
     * @memberof ClientAllClaimReadDto
     */
    clientName?: string | null;
    /**
     * Тип клейма
     * @type {string}
     * @memberof ClientAllClaimReadDto
     */
    type: string;
    /**
     * Значение клейма
     * @type {string}
     * @memberof ClientAllClaimReadDto
     */
    value: string;
    /**
     * Описание клейма
     * @type {string}
     * @memberof ClientAllClaimReadDto
     */
    description?: string | null;
}

/**
 * Check if a given object implements the ClientAllClaimReadDto interface.
 */
export function instanceOfClientAllClaimReadDto(value: object): value is ClientAllClaimReadDto {
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function ClientAllClaimReadDtoFromJSON(json: any): ClientAllClaimReadDto {
    return ClientAllClaimReadDtoFromJSONTyped(json, false);
}

export function ClientAllClaimReadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientAllClaimReadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'clientId': json['clientId'],
        'clientName': json['clientName'] == null ? undefined : json['clientName'],
        'type': json['type'],
        'value': json['value'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function ClientAllClaimReadDtoToJSON(json: any): ClientAllClaimReadDto {
    return ClientAllClaimReadDtoToJSONTyped(json, false);
}

export function ClientAllClaimReadDtoToJSONTyped(value?: ClientAllClaimReadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clientId': value['clientId'],
        'clientName': value['clientName'],
        'type': value['type'],
        'value': value['value'],
        'description': value['description'],
    };
}

